import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { useEffect } from 'react';
import { mergeProps } from 'react-aria';
import ariaHideOutside from './aria-hide-outside.esm.js';
import { useOverlayFocusContain } from './overlay.esm.js';
import useOverlay from './use-overlay.esm.js';
import usePreventScroll from './use-prevent-scroll.esm.js';

/**
 * Provides the behavior and accessibility implementation for a modal component.
 * A modal is an overlay element which blocks interaction with elements outside it.
 */
function useModalOverlay(props, state, ref) {
  var _useOverlay = useOverlay(_objectSpread2(_objectSpread2({}, props), {}, {
      isOpen: state.isOpen,
      onClose: state.close
    }), ref),
    overlayProps = _useOverlay.overlayProps,
    underlayProps = _useOverlay.underlayProps;
  usePreventScroll({
    isDisabled: !state.isOpen
  });
  useOverlayFocusContain();
  useEffect(function () {
    if (state.isOpen && ref.current) {
      return ariaHideOutside([ref.current]);
    }
    return;
  }, [state.isOpen, ref]);
  return {
    modalProps: mergeProps(overlayProps),
    underlayProps: underlayProps
  };
}

export { useModalOverlay as default };
//# sourceMappingURL=use-modal-overlay.esm.js.map
